// extracted by mini-css-extract-plugin
export default {"button":"button_button__UQ77E"};